// @generated by protobuf-ts 2.9.4
// @generated from protobuf file "mlmbox/types/status.proto" (package "mlmbox.types", syntax proto3)
// tslint:disable
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
/**
 * @generated from protobuf message mlmbox.types.Status
 */
export interface Status {
}
/**
 * @generated from protobuf enum mlmbox.types.Status.Auth
 */
export enum Status_Auth {
    /**
     * Guest
     *
     * @generated from protobuf enum value: AUTH_GUEST = 0;
     */
    GUEST = 0,
    /**
     * Authorization
     *
     * @generated from protobuf enum value: AUTH_SIGN_IN = 1;
     */
    SIGN_IN = 1,
    /**
     * Registration
     *
     * @generated from protobuf enum value: AUTH_SIGN_UP = 2;
     */
    SIGN_UP = 2
}
/**
 * @generated from protobuf enum mlmbox.types.Status.Referral
 */
export enum Status_Referral {
    /**
     * No referral
     *
     * @generated from protobuf enum value: REFERRAL_UNKNOWN = 0;
     */
    UNKNOWN = 0,
    /**
     * Error referral link
     *
     * @generated from protobuf enum value: REFERRAL_WRONG_LINK = 1;
     */
    WRONG_LINK = 1,
    /**
     * The user already has a referral (It is not possible to change the referral)
     *
     * @generated from protobuf enum value: REFERRAL_BUSY = 2;
     */
    BUSY = 2,
    /**
     * The referral already exists
     *
     * @generated from protobuf enum value: REFERRAL_EXISTS = 3;
     */
    EXISTS = 3
}
/**
 * @generated from protobuf enum mlmbox.types.Status.TokenValidate
 */
export enum Status_TokenValidate {
    /**
     * @generated from protobuf enum value: TOKEN_VALIDATE_UNKNOWN = 0;
     */
    UNKNOWN = 0,
    /**
     * @generated from protobuf enum value: TOKEN_VALIDATE_ACTIVATED = 1;
     */
    ACTIVATED = 1,
    /**
     * @generated from protobuf enum value: TOKEN_VALIDATE_EXPIRED = 2;
     */
    EXPIRED = 2,
    /**
     * @generated from protobuf enum value: TOKEN_VALIDATE_INVALID = 3;
     */
    INVALID = 3
}
/**
 * @generated from protobuf enum mlmbox.types.Status.GoogleAuthenticator
 */
export enum Status_GoogleAuthenticator {
    /**
     * @generated from protobuf enum value: GOOGLE_AUTHENTICATOR_DEACTIVATED = 0;
     */
    DEACTIVATED = 0,
    /**
     * @generated from protobuf enum value: GOOGLE_AUTHENTICATOR_ACTIVATED = 1;
     */
    ACTIVATED = 1,
    /**
     * @generated from protobuf enum value: GOOGLE_AUTHENTICATOR_REQUESTED = 2;
     */
    REQUESTED = 2
}
/**
 * @generated from protobuf enum mlmbox.types.Status.GoogleAuthenticatorVerifiedCode
 */
export enum Status_GoogleAuthenticatorVerifiedCode {
    /**
     * @generated from protobuf enum value: GOOGLE_AUTHENTICATOR_VERIFIED_CODE_UNKNOWN = 0;
     */
    UNKNOWN = 0,
    /**
     * @generated from protobuf enum value: GOOGLE_AUTHENTICATOR_VERIFIED_CODE_APPROVED = 1;
     */
    APPROVED = 1,
    /**
     * @generated from protobuf enum value: GOOGLE_AUTHENTICATOR_VERIFIED_CODE_REJECTED = 2;
     */
    REJECTED = 2,
    /**
     * @generated from protobuf enum value: GOOGLE_AUTHENTICATOR_VERIFIED_CODE_WRONG_CODE = 3;
     */
    WRONG_CODE = 3
}
/**
 * @generated from protobuf enum mlmbox.types.Status.Confirmation
 */
export enum Status_Confirmation {
    /**
     * @generated from protobuf enum value: CONFIRMATION_ACTIVATED = 0;
     */
    ACTIVATED = 0,
    /**
     * @generated from protobuf enum value: CONFIRMATION_APPROVED = 1;
     */
    APPROVED = 1,
    /**
     * @generated from protobuf enum value: CONFIRMATION_REJECT = 2;
     */
    REJECT = 2,
    /**
     * @generated from protobuf enum value: CONFIRMATION_CANCELED = 3;
     */
    CANCELED = 3,
    /**
     * @generated from protobuf enum value: CONFIRMATION_EXPIRED = 4;
     */
    EXPIRED = 4
}
/**
 * @generated from protobuf enum mlmbox.types.Status.ConfirmationForm
 */
export enum Status_ConfirmationForm {
    /**
     * @generated from protobuf enum value: CONFIRMATION_FORM_REJECTED = 0;
     */
    REJECTED = 0,
    /**
     * @generated from protobuf enum value: CONFIRMATION_FORM_APPROVED = 1;
     */
    APPROVED = 1
}
/**
 * @generated from protobuf enum mlmbox.types.Status.Transaction
 */
export enum Status_Transaction {
    /**
     * @generated from protobuf enum value: TRANSACTION_PROCESSING = 0;
     */
    PROCESSING = 0,
    /**
     * @generated from protobuf enum value: TRANSACTION_SUCCESS = 1;
     */
    SUCCESS = 1,
    /**
     * @generated from protobuf enum value: TRANSACTION_REJECTED = 2;
     */
    REJECTED = 2
}
// @generated message type with reflection information, may provide speed optimized methods
class Status$Type extends MessageType<Status> {
    constructor() {
        super("mlmbox.types.Status", []);
    }
    create(value?: PartialMessage<Status>): Status {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<Status>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Status): Status {
        return target ?? this.create();
    }
    internalBinaryWrite(message: Status, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message mlmbox.types.Status
 */
export const Status = new Status$Type();
